import { playlistsCollection, playlistsSongsCollection } from "../firebase";
import store from "@/store"

const PlaylistService = {
	_keyForPlaylistSong(playlist, song) {
		return playlist.id + ":" + song.songId;
	},

	createPlaylist(title) {
		playlistsCollection.add({
			title: title,
			userId: store.state.currentUser.uid
		});
	},

	setPlaylist(playlist) {
		playlistsCollection.doc(playlist.id).update({
			title: playlist.title,
			color: "color" in playlist ? playlist.color : null
		});
	},

	removePlaylist(playlist) {
		playlistsCollection.doc(playlist.id).delete();
	},

	addSongToPlaylist(playlist, song) {
		var order = 1000;
		if (playlist.id in store.state.playlistsSongsOrders) {
			order = Math.max(...Object.values(store.state.playlistsSongsOrders[playlist.id]));
		}

		playlistsSongsCollection.doc(this._keyForPlaylistSong(playlist, song)).set({
			userId: store.state.currentUser.uid,
			playlistId: playlist.id,
			songId: song.songId,
			order: order ? (order + 1000) : 1000
		});
	},

	removeSongFromPlaylist(playlist, song) {
		playlistsSongsCollection.doc(this._keyForPlaylistSong(playlist, song)).delete();
	},

	sortSongInPlaylist(playlist, song, order) {
		playlistsSongsCollection.doc(this._keyForPlaylistSong(playlist, song)).update({
			order: order
		});
	}
};

export {
	PlaylistService
};
